import React, {Component} from 'react';
import {connect} from 'react-redux';
import ReactSVG from 'react-svg';
import {warningSelector} from '../../../selectors/configSelectors';
import './style.css';
import {toBool} from '../../../reducers/configReducer';

const style = {
  icon: {
    marginRight: 0,
    height: 20,
    width: 20,
    position: 'relative',
    marginBottom: -4
   
  },
  leftBlock: {
    fontWeight: 'bold',
    height: '20px'
  },
  wrapper: {
    width: '75%',
    margin: 'auto'
  },
  warningContainer: {display: "flex", flexDirection: "row", alignItems: "baseline"},

};

class Warning extends Component {
  constructor(props) {
    super(props);
    this.state = {};

  }

    renderLogo = () => {
      if (this.props.logo) return (<img alt="logo" style={style.icon} src={this.props.logo}/>);
      return (<ReactSVG style={style.icon} path={require('./Warning.svg')} role="logo" alt="Warning"/>);
    };

    createMessage() {
      let warningMessage = this.props.warningMessage || "";

      const SCRIPT_REGEX = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
      while (SCRIPT_REGEX.test(warningMessage)) {
        warningMessage = warningMessage.replace(SCRIPT_REGEX, '');
      }

      return {__html: `<div class="inner-preview-layout">${warningMessage}</div>`};
    }

    render() {
      if (!this.props.featureAvailable) {
        return null;
      }

      return (
        <div style={style.wrapper}>
          <div className="container" style={style.warningContainer}>
            <div className="title ">
              {this.renderLogo()}
            </div>
            <div className="message" dangerouslySetInnerHTML={this.createMessage()} />
          </div>
        </div>
      );
    }
}

const mapStateToProps = state => ({
  logo: state.config.WARNING_ICON,
  featureAvailable: toBool(state.config.P65WARNING_FEATURE_AVAILABLE),
  warningMessage: warningSelector(state)
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Warning);



// WEBPACK FOOTER //
// ./src/components/Checkout/Warning/Warning.jsx